export const palette = {
  primary: {
    main: '#082753',
    contrastText: '#fffefa',
  },
  secondary: {
    main: '#fffefa',
    contrastText: '#082753',
  },
  text: {
    primary: '#111111',
    secondary: 'rgba(17, 17, 17, 0.7)',
  },
  background: {
    default: '#fffefa',
    paper: '#ffffff',
  },
  cream: '#fffefa',
  navy: '#082753',
}
